// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"7172812c","785":"e3e2620c","808":"04537d34"}[chunkId] + ".chunk.css";
};